import { useRouter } from "next/router";
import React, { useEffect } from "react";
import Api from "src/data/api";

const withLocationLock = (condition) => (Component) => {
    const WithLocationLock = (props) => {
        const router = useRouter();

        useEffect(() => {
            Api.request({ url: "/user/me" }).then(({ data }) => {
                if (data.location_lock) {
                    router.push("/");
                }
            });
        }, []);

        return (
                    <Component {...props} />
        );
    };

    return WithLocationLock;
};

export default withLocationLock;
